export const personalizedGreeting = (
  yearsMember: number,
  companyProvidedProduction: boolean,
  companyProvidedPayment: boolean,
  // TODO lawrence add updated interface for Membership Greeting step
  greetingProps: any
) => {
  let greeting = { production: "", certifyingLetters: "", payment: "" };
  if (yearsMember > 9) {
    if (companyProvidedProduction) {
      switch (companyProvidedPayment) {
        case true:
          greeting = {
            production:
              greetingProps.tenYearCompanyProductionAndPayment.production,
            certifyingLetters:
              greetingProps.tenYearCompanyProductionAndPayment
                .certifyingLetters,
            payment: greetingProps.tenYearCompanyProductionAndPayment.payment,
          };
          break;

        case false:
          greeting = {
            production:
              greetingProps.tenYearCompanyProductionNoPayment.production,
            certifyingLetters:
              greetingProps.tenYearCompanyProductionNoPayment.certifyingLetters,
            payment: greetingProps.tenYearCompanyProductionNoPayment.payment,
          };
          break;

        default:
          break;
      }
    } else {
      switch (companyProvidedPayment) {
        case false:
          greeting = {
            production: greetingProps.tenYearNoProductionNoPayment.production,
            certifyingLetters:
              greetingProps.tenYearNoProductionNoPayment.certifyingLetters,
            payment: greetingProps.tenYearNoProductionNoPayment.payment,
          };
          break;

        case true:
          greeting = {
            production:
              greetingProps.tenYearNoProductionCompanyPayment.production,
            certifyingLetters:
              greetingProps.tenYearNoProductionCompanyPayment.certifyingLetters,
            payment: greetingProps.tenYearNoProductionCompanyPayment.payment,
          };
          break;

        default:
          break;
      }
    }
  } else if (yearsMember <= 9) {
    if (companyProvidedProduction) {
      switch (companyProvidedPayment) {
        case true:
          greeting = {
            production: greetingProps.companyProductionAndPayment.production,
            certifyingLetters:
              greetingProps.companyProductionAndPayment.certifyingLetters,
            payment: greetingProps.companyProductionAndPayment.payment,
          };
          break;

        case false:
          greeting = {
            production: greetingProps.companyProductionNoPayment.production,
            certifyingLetters:
              greetingProps.companyProductionNoPayment.certifyingLetters,
            payment: greetingProps.companyProductionNoPayment.payment,
          };
          break;

        default:
          break;
      }
    } else if (!companyProvidedProduction) {
      switch (companyProvidedPayment) {
        case true:
          greeting = {
            production: greetingProps.companyPaymentNoProduction.production,
            certifyingLetters:
              greetingProps.companyPaymentNoProduction.certifyingLetters,
            payment: greetingProps.companyPaymentNoProduction.payment,
          };
          break;

        case false:
          greeting = {
            production: greetingProps.noPaymentNoProduction.production,
            certifyingLetters:
              greetingProps.noPaymentNoProduction.certifyingLetters,
            payment: greetingProps.noPaymentNoProduction.payment,
          };
          break;

        default:
          break;
      }
    }
  }

  return greeting;
};

export default {};
